var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingQiwaBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5169 2.63724C10.1966 2.45425 9.80352 2.45425 9.48328 2.63724L2.19177 6.80382C1.69228 7.08924 1.51875 7.72554 1.80417 8.22502C1.99623 8.56113 2.34717 8.74965 2.70839 8.75005V16.0414C2.13311 16.0414 1.66675 16.5077 1.66675 17.083C1.66675 17.6583 2.13311 18.1247 2.70839 18.1247H17.2914C17.8667 18.1247 18.3331 17.6583 18.3331 17.083C18.3331 16.5077 17.8667 16.0414 17.2914 16.0414V8.75005C17.6528 8.74977 18.0039 8.56124 18.196 8.22502C18.4814 7.72554 18.3079 7.08924 17.8084 6.80382L10.5169 2.63724ZM5.83333 9.79151C5.25804 9.79151 4.79168 10.2579 4.79168 10.8332V13.9581C4.79168 14.5334 5.25804 14.9997 5.83333 14.9997C6.40861 14.9997 6.87497 14.5334 6.87497 13.9581V10.8332C6.87497 10.2579 6.40861 9.79151 5.83333 9.79151ZM8.95826 10.8332C8.95826 10.2579 9.42462 9.79151 9.9999 9.79151C10.5752 9.79151 11.0415 10.2579 11.0415 10.8332V13.9581C11.0415 14.5334 10.5752 14.9997 9.9999 14.9997C9.42462 14.9997 8.95826 14.5334 8.95826 13.9581V10.8332ZM14.1665 9.79151C13.5912 9.79151 13.1248 10.2579 13.1248 10.8332V13.9581C13.1248 14.5334 13.5912 14.9997 14.1665 14.9997C14.7418 14.9997 15.2081 14.5334 15.2081 13.9581V10.8332C15.2081 10.2579 14.7418 9.79151 14.1665 9.79151Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingQiwaBank);
export default __webpack_public_path__ + "static/media/onboarding-qiwa-bank.406ec113ef1aadc6864d38147317ffd3.svg";
export { ForwardRef as ReactComponent };